var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 4.91675H16.6668",
    stroke: "#B00101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.9585 7.85425L4.62447 17.0171C4.79378 17.9483 5.60479 18.6251 6.55123 18.6251H11.1158C12.0623 18.6251 12.8733 17.9482 13.0426 17.0171L14.7086 7.85425",
    stroke: "#B00101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.896 2.95834C5.896 1.87678 6.77278 1 7.85434 1H9.81268C10.8943 1 11.771 1.87678 11.771 2.95834V4.91669H5.896V2.95834Z",
    stroke: "#B00101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9fb0c3f60eb4919a47132b777e877030.svg";
export { ForwardRef as ReactComponent };